import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "table-index-cell" }
const _hoisted_4 = { class: "table-index-cell__order" }
const _hoisted_5 = { class: "table-index-cell__id" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, "Mô tả", -1)
const _hoisted_7 = { style: {"word-break":"break-word !important"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      width: "20%",
      "is-display": _ctx.isDeletingModalDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDeletingModalDisplay = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeletingModalDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingDanhMucToaXe)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
              _createTextVNode(" Bạn hãy chắc chắn muốn xóa nhóm toa xe "),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.deletingDanhMucToaXe.ten_danh_muc), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "cell-class-name": _ctx.isTextDangerColumn,
      "empty-text": "Chưa có nhóm toa xe nào được tạo",
      style: {"width":"100%"},
      size: "medium",
      "cell-style": { padding: '0', height: '10px' },
      border: true,
      data: _ctx.items,
      "row-class-name": _ctx.rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "70"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1),
              _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(scope.row.id) + ")", 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Tên",
          width: "300"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ten_danh_muc), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Mã",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ma_danh_muc), 1)
          ]),
          _: 1
        }),
        (_ctx.showNhomCha)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "Nhóm cha"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.parent?.ten_danh_muc ? scope.row.parent.ten_danh_muc : "-"), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, null, {
          header: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_7, _toDisplayString(scope.row.mo_ta ? scope.row.mo_ta : "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          width: "70",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_Setting, {
              actions: _ctx.getSettingActions(scope.row)
            }, null, 8, ["actions"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["cell-class-name", "data", "row-class-name"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ], 64))
}